import AppConstants from '../constants/AppConstants';
import store from '../stores/redux';
import api from '../api';
import handleError from '../helpers/requestErrorHandler';

const { dispatch } = store;
const PublisherBanners = {
    getBanners(params, callback) {
        dispatch({
            type: AppConstants.BANNERS_SEARCH_START_LOADING
        });

        return api.searchBanners(params)
        .then(data => {
            dispatch({
                type  : AppConstants.BANNERS_SEARCH_SUCCESS,
                items : data.response || {}
            });

            callback && callback();
        })
        .catch(err => {
            handleError(err, () => {
                dispatch({
                    type: AppConstants.BANNERS_FAIL,
                    error: err
                });
            });
        });
    },

    getLocales(params) {
        return api.searchBannerLocales(params)
            .then(data => {
                dispatch({
                    type  : AppConstants.BANNERS_LOCALES_SUCCESS,
                    items : data.response || {}
                });
            })
            .catch(err => {
                handleError(err, () => {});
            });
    },

    getDimensions(params) {
        return api.searchBannerDimensions(params)
            .then(data => {
                dispatch({
                    type  : AppConstants.BANNERS_DIMENSIONS_SUCCESS,
                    items : data.response || {}
                });
            })
            .catch(err => {
                handleError(err, () => {});
            });
    },

    getMimeTypes(params) {
        return api.searchBannerMimeTypes(params)
            .then(data => {
                dispatch({
                    type  : AppConstants.BANNERS_MIME_TYPES_SUCCESS,
                    items : data.response || {}
                });
            })
            .catch(err => {
                handleError(err, () => {});
            });
    },

    saveBannerPresets(params) {
        return api.saveBannerPresets(params);
    }
};

export default PublisherBanners;
